import {useState} from "react";
import {SurveyResponseService} from "application/services/SurveyResponseService";
import {SurveyPayload} from "infrastructure/services/surveyResponse.service";

export function useSurveyResponse() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const enviarGuia = async (payload: SurveyPayload) => {
        setLoading(true);
        setError(null);
        try {
            await SurveyResponseService.enviarGuia(payload);
        } catch (err) {
            setError(err as Error);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return {
        enviarGuia,
        loading,
        error,
    };
}
